import fetch from '@/api/fetch';

/** 查询黑名单花名册 */
export const heimindanList = wageQuery => fetch.post('/proBlkList/heimindanList', wageQuery);
/** 查询黑名单可维护列表 */
export const hmdList = wageQuery => fetch.post('/proBlkList/hmdList', wageQuery);

/** 添加黑名单 */
export const join = wageQuery => fetch.post('/proBlkList/join', wageQuery);//,{'X-Requested-With': 'XMLHttpRequest'}

/** 查询待审批列表 */
export const unApprovalList = (data, params) => fetch.post('/proBlkList/unApprovalList', data, { params });

/**审批 */
export const approval = ( data) => fetch.post('/proBlkList/approval', data);
/**批量审批 */
export const approvalBatch = ( data) => fetch.post('/proBlkList/approvalBatch', data);

/**根据姓名、身份证号、手机号模糊查询员工 */
export const userByCondition = (params) => fetch.post('/proBlkList/userByCondition',  params);
/**根据员工id查询单位、项目、施工队、班组 */
export const listByCondition = (params) => fetch.post('/proBlkList/listByCondition',  params);

/**工资删除（批量与单个） */
export const delBatch = ( data) => fetch.post('/proBlkList/delBatch', data);

/** 附件上传 */
export const uploadFiles = fs => fetch.post('/file/uploads', fs,{'X-Requested-With': 'XMLHttpRequest'});
/** 附件上传 */
export const uploadFile = fs => fetch.post('/file/upload', fs,{'X-Requested-With': 'XMLHttpRequest'});
/** 附件删除 */
export const delFile = path => fetch.post('/file/delFile',path);
/** 附件删除 */
export const delFiles = path => fetch.post('/file/delFiles',path);
/** 文件下载 */
export const downFile = filePath => fetch.post('/proBlkList/downImg', filePath,{responseType:'blob'})
/** 黑名单花名册导出 */
export const expHmdList = ao => fetch.post('/proBlkList/expHmdList', ao,{responseType:'blob'})